// src/firebase.js
import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

const firebaseConfig = {
 apiKey: "AIzaSyD8IpHGrjebn1jsj0jw0eAjaxhEqs-2YmI",
  authDomain: "proschoolerp-react.firebaseapp.com",
  projectId: "proschoolerp-react",
  storageBucket: "proschoolerp-react.firebasestorage.app",
  messagingSenderId: "312567646309",
  appId: "1:312567646309:web:85ec7dd646228aa1b75e8c",
  measurementId: "G-JDBL1Z8C2Y"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const messaging = getMessaging(app);

// Request user permission and get device token.
// Guarded so concurrent calls share one request — parallel getToken() calls
// race and mint two different tokens (the first becomes stale).
let tokenPromise = null;

export const requestForToken = () => {
  if (!tokenPromise) {
    tokenPromise = (async () => {
      const permission = await Notification.requestPermission();
      if (permission !== "granted") {
        tokenPromise = null; // allow retrying if the user grants permission later
        return null;
      }

      try {
        const registration = await navigator.serviceWorker.register(
          "/firebase-messaging-sw.js",
          { type: "module" }
        );

        const currentToken = await getToken(messaging, {
          // Generate this in Firebase Console -> Cloud Messaging settings
          vapidKey:
            "BP8C5-Ot_exrPtoJzbSwWSDcnsDJ6YGxXB3B4oNUFyjqfv5twDw_qlnoiD_2kSD942FZre6JY-PcUp8IoTTszho",
          serviceWorkerRegistration: registration,
        });

        if (currentToken) {
          console.log("FCM Device Token:", currentToken);
          // Send this token to your server database to target this user later
           localStorage.setItem('fcm_token', currentToken);
localStorage.setItem('app_name', "FCM React App");
          return currentToken;
        }

        console.log("No registration token available. Request permission to generate one.");
        tokenPromise = null;
        return null;
      } catch (err) {
        tokenPromise = null; // allow retrying after a failure
        console.error("An error occurred while retrieving token.", err);
        if (err.name === "AbortError" && /push service/i.test(err.message)) {
          console.error(
            "The browser's push service rejected the subscription." +
              " Note: ungoogled-Chromium forks (e.g. Helium) cannot use FCM web push" +
              " because Google services are removed — test in Chrome, Edge, Firefox, or Safari." +
              " Also check OS-level notification permission for the browser."
          );
        }
        return null;
      }
    })();
  }
  return tokenPromise;
};

// Listen to foreground notifications. Pass a callback; returns an unsubscribe function.
export const onMessageListener = (callback) => onMessage(messaging, callback);
